import React from "react";
import {NavLink} from "react-router-dom";
import {Calendar2Check, House, ListUl} from "react-bootstrap-icons";
import styles from "./BottomNav.module.scss";

type BottomNavItem = {
    to: string;
    label: string;
    icon: React.ReactNode;
    end?: boolean;
};

const navItems: BottomNavItem[] = [
    {to: "/", label: "Главная", icon: <House size={22}/>, end: true},
    {to: "/services", label: "Услуги", icon: <ListUl size={22}/>},
    {to: "/online_record", label: "Запись", icon: <Calendar2Check size={22}/>},
    //{to: "/faqs", label: "FAQ", icon: <InfoCircle size={22}/>},
];

function BottomNav() {
    return (
        <nav className={styles.bottomNav} aria-label="Нижнее меню">
            {navItems.map((item) => (
                <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    className={({isActive}) =>
                        `${styles.item} ${isActive ? styles.itemActive : ""}`
                    }
                >
                    <span className={styles.icon}>{item.icon}</span>
                    <span className={styles.label}>{item.label}</span>
                </NavLink>
            ))}
        </nav>
    );
}

export default BottomNav;

